var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCompanyDocumentation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 27.0057H4C2.8954 27.0057 2 26.1103 2 25.0057V5.0057C2 3.9011 2.8954 3.0057 4 3.0057L11.17 3C11.703 2.9996 12.2142 3.212 12.59 3.59L16 7.0057L28 7C29.1046 7 30 7.8954 30 9V13.0057H28V9.0057L15.17 9L14.59 8.41L11.17 5L4 5.0057V25.0057H12V27.0057ZM16 16.0057L13.9928 16L14 27.0057H16V16.0057ZM29.9954 17.9983L29.9915 27.764C29.9915 28.4478 29.4239 29.0057 28.7261 29.0057H19.2582C18.5604 29.0057 17.9928 28.4478 17.9928 27.7631V15.2436C17.9928 14.5579 18.5604 14 19.2582 14L26 14.0057L30 18.0057L29.9954 17.9983ZM27.9899 27.0061L28 19.0057H25V16.0057H20V27.0057H28L27.9899 27.0061Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCompanyDocumentation);
export default __webpack_public_path__ + "static/media/ic-company-documentation.d7276a73bc89e27413209e572ea645c0.svg";
export { ForwardRef as ReactComponent };